var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Select from 'react-select';
import Label from '../../../../components/Label';
import classNames from 'classnames';
import t from '../../../../lib/translate';
var LabeledMultiSelect = function (props) {
    var handleSelectAll = function () {
        props.onChange(props.options);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "labeled-multi-select-header" }, { children: [_jsx(Label, { label: props.label }), _jsxs("span", __assign({ className: classNames('select-all-btn'), onClick: handleSelectAll }, { children: [" ", t('users.select.all'), " "] }))] })), _jsx(Select, { isMulti: true, value: props.values, options: props.options, onChange: function (events) {
                    props.onChange(events.map(function (selected) { return ({ value: selected.value, label: selected.label }); }));
                }, isClearable: true, closeMenuOnSelect: false })] }));
};
export default LabeledMultiSelect;
